export const updateDroneDeployLinks = {
    mutation: `mutation updateDroneDeployLinks($modifiedLinks: ModifiedLinks) {
        updateDroneDeployLinks(modifiedLinks: $modifiedLinks)
    }`,
};